module.exports = __webpack_public_path__ + "img/no_image.f3254b79.svg";